(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ZzDev = Lfl.ZzDev || {};

    (function (ZzDev, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.ZzDev, 'ObjectSimplifier')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Converts objects to a simpler form which can then easily be converted into JSON.
         *
         * TODO Later - Resolve the issue that this does not get applied recursively, so it only handles the top-level
         *      object and then JSON.prune handles the rest.
         *        Proposal: Consider even modifying the JSON.prune. Ideally, to accept a callback which will handle each
         *        object's simplification, so we can pass our own function AND make a pull request to the repository.
         * @memberOf Lfl.ZzDev
         */
        Lfl.ZzDev.ObjectSimplifier = ZzDev.ObjectSimplifier || {};

        (function (ObjectSimplifier, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * @memberOf Lfl.ZzDev.ObjectSimplifier
             */
            ObjectSimplifier.simplify = function (object, maxDepth) {
                // Note: This code is still experimental and needs improvements.
                if (isJquery(object)) {
                    return serializeJquery(object, maxDepth);
                }

                if (isNode(object) || isElement(object)) {
                    return serializeNode(object, maxDepth);
                }

                if (isEvent(object)) {
                    return serializeEvent(object, maxDepth);
                }

                // Default
                return serializeSimpleObject(object, maxDepth);
            };

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */

            /*
             |----------------------------------------------------------------------------------------
             | Object type detection for printing
             |------------------------------------
             | Later: might be moved to own object */

            // Source: https://stackoverflow.com/a/384380/5500468

            //Returns true if it is a DOM node
            function isNode(o) {
                return (
                    typeof Node === "object" ? o instanceof Node :
                        o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
                );
            }

            //Returns true if it is a DOM element
            function isElement(o) {
                return (
                    typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                        o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
                );
            }

            function isEvent(o) {
                return o instanceof Event || o.originalEvent instanceof Event;
            }

            function isJquery(o) {
                return o instanceof jQuery;
            }


            /*
             |-------------------------------------------------------------------------
             | Event */
            // Source: https://stackoverflow.com/a/42284488/5500468

            // Generate a JSON version of the event.
            var serializeEvent = function (e, maxDepth) {
                if (e) {
                    if (e.hasOwnProperty('originalEvent')) {
                        e = e.originalEvent;
                    }
                    var o = {
                        eventName: e.toString(), // TODO Later - consider replacing by accessing the prototype.
                        altKey: e.altKey,
                        bubbles: e.bubbles,
                        button: e.button,
                        buttons: e.buttons,
                        cancelBubble: e.cancelBubble,
                        cancelable: e.cancelable,
                        clientX: e.clientX,
                        clientY: e.clientY,
                        composed: e.composed,
                        ctrlKey: e.ctrlKey,
                        currentTarget: e.currentTarget ?
                            ObjectSimplifier.simplify(e.currentTarget, maxDepth - 1) : null,
                        defaultPrevented: e.defaultPrevented,
                        detail: e.detail,
                        eventPhase: e.eventPhase,
                        fromElement: e.fromElement ?
                            ObjectSimplifier.simplify(e.currentTarget, maxDepth - 1) : null,
                        isTrusted: e.isTrusted,
                        layerX: e.layerX,
                        layerY: e.layerY,
                        metaKey: e.metaKey,
                        movementX: e.movementX,
                        movementY: e.movementY,
                        offsetX: e.offsetX,
                        offsetY: e.offsetY,
                        pageX: e.pageX,
                        pageY: e.pageY,
                        path: FullDomPathProvider.getAlternativePathToElement(e.path && e.path.length ? e.path[0] : null),
                        relatedTarget: e.relatedTarget ?
                            ObjectSimplifier.simplify(e.currentTarget, maxDepth - 1) : null,
                        returnValue: e.returnValue,
                        screenX: e.screenX,
                        screenY: e.screenY,
                        shiftKey: e.shiftKey,
                        sourceCapabilities: e.sourceCapabilities ? e.sourceCapabilities.toString() : null,
                        target: e.target ?
                            ObjectSimplifier.simplify(e.currentTarget, maxDepth - 1) : null,
                        timeStamp: e.timeStamp,
                        toElement: e.toElement ?
                            ObjectSimplifier.simplify(e.currentTarget, maxDepth - 1) : null,
                        type: e.type,
                        view: e.view ? e.view.toString() : null,
                        which: e.which,
                        x: e.x,
                        y: e.y
                    };

                    return serializeSimpleObject(o, maxDepth);
                }
            };

            /*
            |-------------------------------------------------------------------------
            | Others */
            function serializeSimpleObject(object, maxDepth) {
                return JSON.parse(JSON.prune(object, {depthDecr: maxDepth}));
            }

            function serializeNode(object, maxDepth) {
                // Note: Even though the conversion there and back adds some overhead, it is a very small one.
                return JSON.parse(JSON.prune(object, {
                    replacer: function (key, value, depth, maxDepth) {
                        if (depth === 1) {
                            switch (key) {
                                case "id":
                                case "tagName":
                                case "className":
                                    return value;
                                case "childNodes":
                                    return _.filter(
                                        _.map(value, function (val) {
                                            if (val.nodeName === "#text" && val.wholeText.trim().length === 0) {
                                                return;
                                            }
                                            return serializeNode(val);
                                        }),
                                        function (val) {
                                            return val !== null && typeof val !== 'undefined';
                                        });
                                default:
                                    return;
                            }
                        }
                        return value;
                    },
                    inheritedProperties: true,
                    depthDecr: maxDepth
                }));
            }

            function serializeJquery(jQuery, maxDepth) {
                return JSON.parse(JSON.prune(jQuery, {
                    replacer: jQueryReplacer,
                    inheritedProperties: true,
                    depthDecr: maxDepth
                }));
            }

            // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify
            function jQueryReplacer(key, value, depth, remainingDepth) {
                if (key === 'prevObject') {
                    return _.map(value, function (value, key) {
                        return typeof value == 'object' ? FullDomPathProvider.getFullDomPath($(value)) : value;
                    });
                }

                if (Lfl.Number.isNumber(key) && typeof value === "object" && depth === 1) {
                    return ObjectSimplifier.simplify(value, remainingDepth);
                }
                return value;
            }
        }(ZzDev.ObjectSimplifier, jQuery));
    }(Lfl.ZzDev, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
